import { client, previewClient } from "../sanity";

export const getClient = (preview) => (preview ? previewClient : client);
